/**
 * Created by joerg on 15.06.17.
 */
import React from 'react'
import {Route, Link} from 'react-router-dom'
import PropTypes from 'prop-types';


export default function NavItem({children, to, exact, disabled}) {
    const classes = [(disabled ? 'disabled' : '')];
    function getclasses(matched) {
        classes.push((matched ? 'active' : ""));
        return classes.join(" ")
    }

    return (
        <Route path={to} exact={exact} children={({match}) => (
            <li className={getclasses(match)}>
                <Link to={to} disabled={disabled}>{children}</Link>
            </li>
        )}/>
    )
}

NavItem.propTypes = {
    to: PropTypes.string.isRequired,
    exact: PropTypes.bool,
    children: PropTypes.node.isRequired,
    disabled: PropTypes.bool
};


// WEBPACK FOOTER //
// ./src/components/NavItem.js